import VpVolumeBar from './bar';
import VideoJsAdapter from '../../../adapters/videojs_adapter';
import Component from '../../component';
import VolumeContainer from './volume_container';
export default class Index extends VideoJsAdapter.getComponent('muteToggle') {
  constructor(player, options = {}){
    super(player, options);
    this.createContainer();
  }

  createEl(){
    var props = {
      innerHTML: '<span aria-hidden="true" class="vjs-icon-placeholder"></span>',
      className: this.buildCSSClass()
    };

    var el = Component.prototype.createEl.call(this, 'div', props);
    this.createControlTextEl(el);
    return el;
  }

  buildCSSClass(){
    return `vjs-volume-menu-button vjs-vp-volume-menu-button ${super.buildCSSClass()}`;
  }

  createContainer(){
    this.volumeContainer = new VolumeContainer();
    this.el().appendChild(this.volumeContainer.el);

    let vb = new VpVolumeBar(this.player_);
    this.volumeContainer.el.appendChild(vb.el());
  }

  handleClick(e){
    if(e.target == this.el()){
      super.handleClick();
    }
  }
}

Component.registerComponent('VpVolumePanel', Index);
